/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timer[_ngcontent-%COMP%]{font-size:1.5em;text-align:center}"];
export { styles as styles };
